<template>
  <div class="dashboard">
    <v-row class="d-md-flex align-center">
      <v-col
        ><h1>{{ $t("dashboard") }}</h1></v-col
      >
      <v-col cols="12" md="1" class="d-flex justify-end"> </v-col>
      <v-col class="filter-box d-flex justify-end" cols="12" md="4">
        <v-btn
          class="btn-two mr-3"
          color="#08a657"
          height="56px"
          depressed
          @click.stop="toggleFiltre()"
        >
          <v-icon medium>mdi-filter-outline</v-icon>
          {{ $t("filter") }}
        </v-btn>

        <v-btn
          class="btn-two"
          color="#08a657"
          height="56px"
          depressed
          @click.stop="toggleCompare()"
        >
          <v-icon medium>mdi-compare</v-icon>
          {{ $t("compare") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-chip
          v-if="dateTimeBegin && dateTimeEnd"
          class="ma-1"
          close
          @click:close="removeFilterDate()"
          small
        >
          <strong>{{ $t("dash.dateRange") }}</strong
          >: {{ dateTimeBegin }} / {{ dateTimeEnd }}
        </v-chip>

        <v-chip
          v-if="
            selectedOrganization && selectedOrganization.id && organisationName
          "
          class="ma-1"
          close
          @click:close="removeFilterOrganisation()"
          small
        >
          <strong>{{ $t("organizations") }}</strong
          >: {{ organisationName }}
        </v-chip>

        <v-chip
          v-if="
            (dateTimeBegin && dateTimeEnd) ||
              (selectedOrganization && selectedOrganization.id)
          "
          class="ma-1"
          close
          @click:close="removeFilterAll()"
          small
          outlined
        >
          <strong>{{ $t("clear") }}</strong>
        </v-chip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-expand-transition>
          <div class="transition-display brd-top-vone" v-show="showFilter">
            <v-card>
              <v-card-text>
                <DashboardFilter
                  :applyFilter="applyFilter"
                  :cancelFilter="cancelFilter"
                  :dateTimeBegin="dateTimeBegin"
                  :dateTimeEnd="dateTimeEnd"
                  :allOrganizations="allOrganizations"
                  :selectedOrganizationId="selectedOrganizationId"
                  :subsidiaries="subsidiaries"
                  :changeSelectedSubsidiaries="changeSelectedSubsidiaries"
                  :orgLoading="orgLoading"
                  :orgSearch="orgSearch"
                  :onOrgSearchInput="onOrgSearchInput"
                  :onOrgClear="onOrgClear"
                  :onOrgOpen="onOrgOpen"
                />
              </v-card-text>
            </v-card>
          </div>
        </v-expand-transition>
      </v-col>

      <v-col cols="12" sm="3" v-for="item in dashboadFields" :key="item.id">
        <DashboardItem :item="item" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import config from "../../config";
import Axios from "axios";
import DashboardFilter from "./DashboardFilter";
import DashboardItem from "./DashboardItem";
const qs = require("querystring");

export default {
  components: { DashboardFilter, DashboardItem },
  name: "Dashboard",
  data() {
    return {
      showFilter: false,

      allOrganizations: [],

      selectedOrganizationId: null,
      selectedOrganizationCache: null,

      subsidiaries: false,

      orgSearch: "",
      orgLoading: false,
      orgLastQuery: null,
      orgDebounceTimer: null,

      dashboadFields: [
        { id: 0, t: "dash.cmrs", name: "count", val: "" },
        { id: 1, t: "dash.assigned", name: "assignedCount", val: "" },
        {
          id: 2,
          t: "dash.signedByDriver",
          name: "signedByDriverCount",
          val: "",
        },
        {
          id: 3,
          t: "dash.signedByReceiver",
          name: "signedByReceiverCount",
          val: "",
        },
        { id: 4, t: "dash.latePickup", name: "latePickupCount", val: "" },
        {
          id: 5,
          t: "dash.totalTimeLatePickup",
          name: "latePickupTime",
          val: "",
        },
        { id: 6, t: "dash.lateDelivery", name: "lateDeliveryCount", val: "" },
        {
          id: 7,
          t: "dash.totalTimeLateDelivery",
          name: "lateDeliveryTime",
          val: "",
        },
        { id: 8, t: "dash.remarksSender", name: "senderRemarksCount", val: "" },
        { id: 9, t: "dash.remarksDriver", name: "driverRemarksCount", val: "" },
        {
          id: 10,
          t: "dash.remarksReceiver",
          name: "receiverRemarksCount",
          val: "",
        },
        { id: 11, empty: true },
        {
          id: 12,
          t: "dash.activeDrivers",
          name: "activeDriversCount",
          val: "",
        },
        {
          id: 13,
          t: "dash.activeSigners",
          name: "activeSignersCount",
          val: "",
        },
      ],

      dateTimeBegin: "",
      dateTimeEnd: "",
    };
  },

  computed: {
    selectedOrganization() {
      return (
        this.allOrganizations.find(
          (x) => x.id === this.selectedOrganizationId
        ) ||
        this.selectedOrganizationCache ||
        null
      );
    },

    organisationName() {
      return this.selectedOrganization?.name || "";
    },
  },

  methods: {
    applyFilter(dateStart = "", dateEnd = "", organisationId, subsidiaries) {
      this.dateTimeBegin = dateStart;
      this.dateTimeEnd = dateEnd;

      this.selectedOrganizationId = organisationId || null;

      // если выбранное есть в списке — запоминаем объект в кеш
      if (this.selectedOrganizationId) {
        const obj = this.allOrganizations.find(
          (x) => x.id === this.selectedOrganizationId
        );
        if (obj) this.selectedOrganizationCache = obj;
      } else {
        this.selectedOrganizationCache = null;
      }

      this.subsidiaries = subsidiaries;

      this.getDashboardInfo();
      this.toggleFiltre();
    },

    cancelFilter() {
      this.subsidiaries = false;
      this.setCurrentMonth();
      this.selectedOrganizationId = null;
      this.selectedOrganizationCache = null;
      this.getDashboardInfo();
      this.toggleFiltre();
    },

    onOrgOpen() {
      // подгружаем первые элементы, если список пуст
      if (!this.allOrganizations.length) {
        this.fetchOrganizations("", { force: true });
      }
    },

    onOrgSearchInput(v) {
      this.orgSearch = v;

      if (this.orgDebounceTimer) clearTimeout(this.orgDebounceTimer);
      this.orgDebounceTimer = setTimeout(() => {
        this.fetchOrganizations(this.orgSearch);
      }, 300);
    },

    onOrgClear() {
      this.orgSearch = "";
      this.selectedOrganizationId = null;
      this.selectedOrganizationCache = null;
      this.subsidiaries = false;
      this.fetchOrganizations("", { force: true });
    },

    async fetchOrganizations(search = "", { force = false } = {}) {
      const q = (search || "").trim();

      if (!force && q === this.orgLastQuery && this.allOrganizations.length)
        return;

      this.orgLastQuery = q;
      this.orgLoading = true;

      try {
        const url =
          config.apiBaseUrl +
          `api/organization/box-list?search=${encodeURIComponent(q)}`;

        const { data } = await Axios.get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        });

        const items = Array.isArray(data) ? data : data.data || [];
        this.allOrganizations = items;

        //обновим кеш выбранного объекта, если он есть в ответе
        if (this.selectedOrganizationId) {
          const obj = items.find((x) => x.id === this.selectedOrganizationId);
          if (obj) this.selectedOrganizationCache = obj;

          // если выбранного нет в выдаче, но кеш есть — добавим его в начало списка
          if (
            !obj &&
            this.selectedOrganizationCache?.id === this.selectedOrganizationId
          ) {
            this.allOrganizations = [this.selectedOrganizationCache, ...items];
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        this.allOrganizations = [];
      } finally {
        this.orgLoading = false;
      }
    },

    getDashboardInfo() {
      const org = this.selectedOrganization;

      const params = {
        begin: this.dateTimeBegin,
        end: this.dateTimeEnd,
        organizationId: this.subsidiaries ? null : org ? org.id : null,
        organizationHId: this.subsidiaries
          ? org
            ? org.organizationsHId
            : null
          : null,
      };

      Axios.get(
        config.apiBaseUrl + `api/cmr/dashboard?${qs.stringify(params)}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.dashboadFields = this.dashboadFields.map((el) => {
              el.val = data[el.name];
              return el;
            });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    toggleFiltre() {
      this.showFilter = !this.showFilter;
    },

    toggleCompare() {
      this.$router.push({ name: "compare" });
    },

    setCurrentMonth() {
      const date = new Date();
      const y = date.getFullYear();
      const m =
        date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      const d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.dateTimeBegin = `${y}-${m}-01`;
      this.dateTimeEnd = `${y}-${m}-${d}`;
    },

    removeFilterDate() {
      this.dateTimeBegin = "";
      this.dateTimeEnd = "";
      this.getDashboardInfo();
    },

    removeFilterOrganisation() {
      this.selectedOrganizationId = null;
      this.selectedOrganizationCache = null;
      this.subsidiaries = false;
      this.getDashboardInfo();
    },

    removeFilterAll() {
      this.dateTimeBegin = "";
      this.dateTimeEnd = "";
      this.selectedOrganizationId = null;
      this.selectedOrganizationCache = null;
      this.subsidiaries = false;
      this.getDashboardInfo();
    },
  },

  created() {
    this.setCurrentMonth();
    this.fetchOrganizations("", { force: true });
    this.getDashboardInfo();
  },
};
</script>
